import { createAsyncThunk } from "@reduxjs/toolkit";
import { AddOnProduct } from "../../../client/services";
import { toastHandler } from "../../../utils/toastHandler";
import { FindAddOnProduct, GetAddOnProduct } from "../../addonProduct/api/interface";

export const findSelectAddOnProduct = createAsyncThunk(
  "selectAddOnProduct/findSelectAddOnProduct",
  async (values: FindAddOnProduct, { rejectWithValue }) => {
    try {
      const response = await AddOnProduct.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const searchSelectAddOnProduct = createAsyncThunk(
  "selectAddOnProduct/searchSelectAddOnProduct",
  async (values: FindAddOnProduct, { rejectWithValue }) => {
    try {
      const response = await AddOnProduct.find({
        query: values,
      });
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);


export const getSelectAddOnProduct = createAsyncThunk(
  'selectAddOnProduct/getSelectAddOnProduct',
  async ({ id }: GetAddOnProduct, { rejectWithValue }) => {
    try {
      const response = await AddOnProduct.get(id, {});

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
